import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-check-circle',
  templateUrl: './icon-check-circle.component.html',
  styleUrls: ['./icon-check-circle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCheckCircleComponent {}
